import { Injectable } from '@angular/core';
import { Effekt } from '../components/aftale/models';

@Injectable({
  providedIn: 'root',
})
export class EffektService {
  public effektPattern: string = '^[0-9]+$|^[0-9]+-[0-9]+$';
  constructor() {}

  getEffekt(effektStr: string) {
    const effekt: Effekt = {};

    if (effektStr) {
      if (effektStr.indexOf('-') > 0) {
        const effektArr = effektStr.split('-');
        effekt.minEffekt = Number(effektArr[0]);
        effekt.maxEffekt = Number(effektArr[1]);
      } else {
        effekt.maxEffekt = Number(effektStr);
      }
    }
    return effekt;
  }

  setEffekt(minEffekt: number, maxEffekt: number): string {
    if (minEffekt && maxEffekt) {
      return minEffekt != maxEffekt ? minEffekt.toString() + '-' + maxEffekt.toString() : minEffekt.toString();
    } else if (maxEffekt) {
      return maxEffekt.toString();
    } else {
      return '';
    }
  }
}
